import React from 'react';

const SIZES = {
  sm: 'w-4 h-4 border-[2px]',
  md: 'w-8 h-8 border-[2.5px]',
  lg: 'w-12 h-12 border-[3px]',
};

/**
 * Két gyűrűből áll: egy halvány alapkör és egy brand színű ív, ami forog.
 * A külső halo adja a mélységet a sötét háttéren.
 */
export default function LoadingSpinner({ size = 'md', fullPage = false, label }) {
  const spinner = (
    <span className="relative inline-flex">
      <span className="absolute inset-0 rounded-full bg-brand-500/25 blur-md animate-glow-pulse" />
      <span
        className={`relative rounded-full border-white/[0.08] border-t-brand-400 border-r-brand-500
                    animate-spin ${SIZES[size] || SIZES.md}`}
      />
    </span>
  );

  if (fullPage) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 min-h-[45vh]">
        {spinner}
        {label && <p className="text-sm text-gray-500">{label}</p>}
      </div>
    );
  }

  if (label) {
    return (
      <span className="inline-flex items-center gap-3">
        {spinner}
        <span className="text-sm text-gray-500">{label}</span>
      </span>
    );
  }

  return spinner;
}
